<div class="dialog">

  <app-header-dialog [iconName]="'noise_control_off'">
    {{data.title}}
  </app-header-dialog>

  <mat-dialog-content>

    <div class='box'>
      <mat-icon class='icon-info'>help</mat-icon>
      <div class='dialog-text' [innerHTML]='data.message'></div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions fxLayoutAlign="space-between" justify-content='flex-end'>
    <button mat-raised-button mat-dialog-close="close">
      <mat-icon class="icon-cancel">highlight_off</mat-icon>
    </button>
    <button type="submit" mat-raised-button mat-dialog-close="ok">
      <mat-icon class="icon-done">check_circle_outline</mat-icon>
    </button>
  </mat-dialog-actions>

</div>